function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { t } from "@/lang";
import { DemandOrderStatusEnum, TradeStatus } from "@pt/enums/order";
export var demandOrderStatusOptions = [
    {
        label: t("playTurbo.order.status.pending").toString(),
        value: "".concat(DemandOrderStatusEnum.PENDING)
    },
    {
        label: t("playTurbo.order.status.doing").toString(),
        value: "".concat(DemandOrderStatusEnum.DOING)
    },
    {
        label: t("playTurbo.order.status.rejected.state").toString(),
        value: DemandOrderStatusEnum.REFUSED
    },
    {
        label: t("playTurbo.order.status.completed").toString(),
        value: DemandOrderStatusEnum.COMPLETED
    },
    {
        label: t("playTurbo.order.status.revoked.state").toString(),
        value: DemandOrderStatusEnum.REVOKED
    }, 
];
var _obj;
export var demandOrderStatusConfig = (_obj = {}, _defineProperty(_obj, DemandOrderStatusEnum.PENDING, {
    color: "pending",
    label: t("playTurbo.order.status.pending").toString(),
    icon: IcUndo
}), _defineProperty(_obj, DemandOrderStatusEnum.DOING, {
    color: "warning",
    label: t("playTurbo.order.status.doing").toString()
}), _defineProperty(_obj, DemandOrderStatusEnum.REFUSED, {
    color: "fail",
    label: t("playTurbo.order.status.rejected.state").toString(),
    icon: IcUploadCloud
}), _defineProperty(_obj, DemandOrderStatusEnum.COMPLETED, {
    color: "success",
    label: t("playTurbo.order.status.completed").toString(),
    icon: IcDownload
}), _defineProperty(_obj, DemandOrderStatusEnum.REVOKED, {
    color: "pending",
    label: t("playTurbo.order.status.revoked.state").toString(),
    icon: IcUploadCloud
}), _obj);
var _obj1;
export var tradeStatusOptionsConfig = (_obj1 = {}, _defineProperty(_obj1, TradeStatus.UNPAID, {
    color: "pending",
    label: t("playTurbo.order.status.unpaid").toString()
}), _defineProperty(_obj1, TradeStatus.PAID, {
    color: "success",
    label: t("playTurbo.order.status.paid").toString()
}), _defineProperty(_obj1, TradeStatus.FAIL, {
    color: "fail",
    label: t("playTurbo.order.status.fail").toString()
}), _obj1);
export var searchFieldOptions = [
    {
        label: t("playTurbo.order.filter.modelName").toString(),
        value: "material_name"
    },
    {
        label: t("playTurbo.order.filter.orderId").toString(),
        value: "id"
    },
    {
        label: t("playTurbo.dashboard.filter.product_name").toString(),
        value: "project_name"
    },
    {
        label: t("playTurbo.dashboard.filter.product_id").toString(),
        value: "project_id"
    }, 
];
